import type { FC } from 'react';
import React from 'react';

import { Box, Typography, useTheme } from '@mui/material';

type InputLabelProps = {
  id?: string;
  label?: string;
  isRequired?: boolean;
  isShowHint?: boolean;
  currentHintValue?: number;
  maxHintValue?: number;
  isBoldLabel?: boolean;
};
export const InputLabel: FC<InputLabelProps> = ({
  id,
  label,
  isRequired,
  isShowHint,
  currentHintValue,
  maxHintValue = 72,
  isBoldLabel = false,
}) => {
  const theme = useTheme();

  const variantLabel = isBoldLabel ? 't14r' : 't12r';

  return (
    <>
      {label || isShowHint ? (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
          <Typography
            component="div"
            variant={variantLabel}
            id={id}
            sx={{
              color: isBoldLabel ? theme.palette.case.neutral.n700 : theme.palette.case.neutral.n500,
              height: '16px',
              fontWeight: isBoldLabel ? '600' : '400',
            }}
          >
            {label}
            {isRequired && (
              <Box component="span" sx={{ color: theme.palette.case.red.r600 }}>
                {' *'}
              </Box>
            )}
          </Typography>

          {isShowHint ? (
            <Typography
              component="div"
              variant="default"
              sx={{
                color: theme.palette.case.neutral.n500,
                height: '20px',
                fontWeight: '500',
              }}
            >
              {`${currentHintValue}/${maxHintValue}`}
            </Typography>
          ) : (
            <></>
          )}
        </Box>
      ) : (
        <></>
      )}
    </>
  );
};
